import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";

import thunkMiddleware from "redux-thunk";
// import { createLogger } from "redux-logger";

import { requestModelDataReducer } from "../reducers/requestModelDataReducer";
import { requestLogOutDataReducer } from "../reducers/requestLogOutDataReducer";
import { requestProjectsDataReducer } from "../reducers/requestProjectsDataReducer";
import { requestSelectedProjectDataReducer } from "../reducers/requestSelectedProjectDataReducer";
import { requestIssuesDataReducer } from "../reducers/requestIssuesDataReducer";
import { requestUserDataReducer } from "../reducers/requestUserDataReducer";
import { requestFileWhiteListReducer } from "../reducers/requestFileWhiteListReducer";
import { requestFolderBlackListReducer } from "../reducers/requestFolderBlackListReducer";
import { requestFilterDataSetReducer } from "../reducers/requestFilterDataSetReducer";
import { requestFilterCategoryReducer } from "../reducers/requestFilterCategoryReducer";
import { requestProjectDataConfig } from "../reducers/requestProjectDataConfig";
import { requestCalculationsConfig } from "../reducers/requestCalculationsConfig";
import { requestReportsConfig } from "../reducers/requestReportsConfig";
import { getMarkdown } from "../reducers/getMarkdown";
import { getStateObjPropertiesReducer } from "../reducers/getStateObjPropertiesReducer";
import { getSelectedModelReducer } from "../reducers/getSelectedModelReducer";
import { getPersonalHubReducer } from "../reducers/getPersonalHubReducer";

import { getSelectedProjectReducer } from "../reducers/getSelectedProjectReducer";
import { getModelArrayReducer } from "../reducers/getModelArrayReducer";
import { getPropertiesReducer } from "../reducers/getPropertiesReducer";
import { requestGeneralSettingsReducer } from "../reducers/requestGeneralSettingsReducer";
import { postProjectData } from "../reducers/postProjectData";
import { postCalculations } from "../reducers/postCalculations";
import metaPropReducer from "../reducers/updateMetaPropReducer";
import { trainingContentReducer } from "../reducers/updateTrainingContent";
import { markupStateReducer } from "../reducers/updateMarkupState";
import { pdfStateReducer } from "../reducers/updatePdfState";
import { workflowStateReducer } from "../reducers/updateWorkflowState";



const reducers = combineReducers({
  requestModelDataReducer,
  requestLogOutDataReducer,
  requestProjectsDataReducer,
  requestSelectedProjectDataReducer,
  requestIssuesDataReducer,
  requestUserDataReducer,
  requestFileWhiteListReducer,
  requestFilterDataSetReducer,
  getSelectedProjectReducer,
  getSelectedModelReducer,
  getPersonalHubReducer,
  getStateObjPropertiesReducer,
  requestFilterCategoryReducer,
  requestFolderBlackListReducer,
  getModelArrayReducer,
  requestGeneralSettingsReducer,
  getPropertiesReducer,
  requestProjectDataConfig,
  requestCalculationsConfig,
  requestReportsConfig,
  getMarkdown,
  postProjectData,
  postCalculations,
  metaPropReducer,
  trainingContentReducer,
  markupStateReducer,
  pdfStateReducer,
  workflowStateReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }

  return reducers(state, action);
};

// Use the logger if you want to see redux requests
// const logger = createLogger({
//   collapsed: true,
// });
// const store = createStore(
//   rootReducer,
//   applyMiddleware(thunkMiddleware, logger)
// );

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunkMiddleware))
);

export default store;
